import { render, staticRenderFns } from "./GoogleTip.vue?vue&type=template&id=1b24eb17&scoped=true&"
import script from "./GoogleTip.vue?vue&type=script&lang=js&"
export * from "./GoogleTip.vue?vue&type=script&lang=js&"
import style0 from "./GoogleTip.vue?vue&type=style&index=0&id=1b24eb17&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b24eb17",
  null
  
)

export default component.exports